<template>
  <el-tooltip effect="dark" :content="tooltipContent" placement="bottom">
    <el-button class="d2-ml-0 d2-mr btn-text can-hover" type="text" @click="handleClick">
      <el-badge v-if="message > 0" :max="99" :value="message" :is-dot="message === 0">
        <!-- <d2-icon
          :name="logLengthError === 0 ? 'dot-circle-o' : 'bug'"
          style="font-size: 20px"/> -->
        <i class="el-icon-message" style="font-size: 20px"></i>
      </el-badge>
      <!-- <d2-icon
        v-else
        name="dot-circle-o"
        style="font-size: 20px"/>           -->
      <!-- <i class="el-icon-message"></i> -->
      <i v-else class="el-icon-message" style="font-size: 20px"></i>

    </el-button>
  </el-tooltip>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import request from '@/plugin/axios'
export default {
  computed: {
    ...mapGetters('d2admin', {
      logLength: 'log/length',
      logLengthError: 'log/lengthError'
    }),
    tooltipContent () {
      return this.message === 0
        ? '没有消息'
        : ` 包含 ${this.message} 个消息`
    }
  },
  data () {
    return {
      message: 0
    }
  },
  mounted () {
    this.getMessage()
  },
  methods: {
    getMessage () {
      request({
        url: 'http://yapi.linkyee.net/mock/88/message/stat',
        method: 'get'
      }).then(res => {
        this.message = res.data.msg_count
      })
    },
    ...mapMutations('d2admin/log', [
      'clean'
    ]),
    handleClick () {
      this.$router.push({
        name: 'log'
      })
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-log/index.vue"
}
</vue-filename-injector>
